'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createModule = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createActionHandler = require('./createActionHandler');

var _createActionHandler2 = _interopRequireDefault(_createActionHandler);

var _createAction = require('./createAction');

var _createAction2 = _interopRequireDefault(_createAction);

var _createReducer = require('./createReducer');

var _createReducer2 = _interopRequireDefault(_createReducer);

var _getDefaultActionHandler = require('./getDefaultActionHandler');

var _getDefaultActionHandler2 = _interopRequireDefault(_getDefaultActionHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createModule = function createModule(_ref) {
  var moduleName = _ref.moduleName,
      initialState = _ref.initialState,
      handlers = _ref.handlers;

  if (typeof initialState === 'undefined') {
    console.error('@redux-modux: initialState is missing in createModule()');
    return;
  }

  var handlerWithDefault = _extends({}, handlers, (0, _getDefaultActionHandler2.default)(initialState));

  var actionHandlers = (0, _createActionHandler2.default)({
    moduleName: moduleName,
    initialState: initialState,
    handlers: handlerWithDefault
  });

  return _extends({
    state: (0, _createReducer2.default)(initialState, actionHandlers)
  }, (0, _createAction2.default)(actionHandlers));
};

exports.createModule = createModule;